"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var bind_1 = require("../bind");
var constants_1 = require("../constants");
// Does this keyboard event print a character to the input?
function isPrinting(e) {
    return e.key.length === 1 && !e.altKey && !e.ctrlKey && !e.metaKey;
}
var UncontrolledInput = /** @class */ (function (_super) {
    tslib_1.__extends(UncontrolledInput, _super);
    function UncontrolledInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UncontrolledInput.prototype.onKeyDown = function (event) {
        if (this.props.numberOnly && isPrinting(event) && !event.key.match(constants_1.NUMBER_OR_FLOAT_KEYS_REGEX)) {
            event.preventDefault();
        }
    };
    Object.defineProperty(UncontrolledInput.prototype, "inputType", {
        get: function () {
            return this.props.inputType || 'text';
        },
        enumerable: true,
        configurable: true
    });
    UncontrolledInput.prototype.shouldRenderInputGroup = function () {
        return (!!this.props.currencyPrefix || !!this.props.currencySuffix);
    };
    UncontrolledInput.prototype.inputGroupClass = function () {
        if (this.shouldRenderInputGroup())
            return 'input-group__input';
        return this.props.className;
    };
    UncontrolledInput.prototype.renderInputOrGroup = function () {
        if (this.shouldRenderInputGroup()) {
            return (React.createElement("div", { className: "input-group" },
                !!this.props.currencyPrefix &&
                    React.createElement("div", { className: "input-group__text" }, this.props.currencyPrefix),
                this.renderInput(),
                !!this.props.currencySuffix &&
                    React.createElement("div", { className: "input-group__text" }, this.props.currencySuffix)));
        }
        return this.renderInput();
    };
    UncontrolledInput.prototype.renderInput = function () {
        return (React.createElement("input", { autoCapitalize: this.props.autoCapitalize, autoComplete: this.props.autoComplete, autoCorrect: this.props.autoCorrect, autoFocus: this.props.autoFocus, disabled: this.props.disabled, id: this.props.id || this.props.inputName, maxLength: this.props.maxLength, name: this.props.inputName, onChange: this.props.onChange, onKeyDown: this.onKeyDown, pattern: this.props.pattern, placeholder: this.props.placeholder, spellCheck: this.props.spellCheck, type: this.inputType, className: this.inputGroupClass() }));
    };
    UncontrolledInput.prototype.render = function () {
        if (this.props.inputType === 'textarea') {
            return (React.createElement("textarea", { autoCapitalize: this.props.autoCapitalize, autoComplete: this.props.autoComplete, autoCorrect: this.props.autoCorrect, autoFocus: this.props.autoFocus, disabled: this.props.disabled, id: this.props.id || this.props.inputName, maxLength: this.props.maxLength, name: this.props.inputName, onChange: this.props.onChange, onKeyDown: this.onKeyDown, placeholder: this.props.placeholder, required: this.props.required, spellCheck: this.props.spellCheck, className: this.props.className }));
        }
        return this.renderInputOrGroup();
    };
    tslib_1.__decorate([
        bind_1.default
    ], UncontrolledInput.prototype, "onKeyDown", null);
    return UncontrolledInput;
}(React.Component));
exports.default = UncontrolledInput;
//# sourceMappingURL=uncontrolled_input.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/uncontrolled_input.js
// module id = ZhUn
// module chunks = 20 21 22